















import Vue from "vue";
import DocumentToolbarAction from "@/components/modules/document/toolbar/DocumentToolbarAction.vue";
import ZenyaDialog from "@/components/dialogs/ZenyaDialog.vue";
import DocumentDetails from "@/components/modules/document/DocumentDetails.vue";
import { DocumentField } from "@infoland/iprova-api";
import storeHelper from "@/store/store-helper";
export default Vue.extend({
    name: "ShowDocumentDetailsAction",
    components: { DocumentToolbarAction, ZenyaDialog, DocumentDetails },
    props: {
        documentFields: Array as () => DocumentField[],
        enable: { default: true },
        isButton: Boolean
    },
    data: function () {
        return {
            showDocumentDetailsDialog: false
        };
    },
    watch: {
        showDocumentDetailsDialog: function () {
            storeHelper.siteStore.setIsDialogDisplayed(this.showDocumentDetailsDialog);
        }
    },
    methods: {
        setShowDocumentDetailsDialog(): void {
            this.showDocumentDetailsDialog = true;
        }
    }
});
